export const validateEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  return {
    isValid: email && emailRegex.test(email),
    message: 'Digite um e-mail com formato válido. Exemplo: meuemail@provedor.com.br'
  };
};

// Must stay in sync with the API's PasswordValidator — same rules, same order, same messages, so the
// text is identical whether it was raised here or came back on a 400. A mismatch would let the form
// enable a save the API then refuses.
export const PASSWORD_RULES: {
  id: string;
  label: string;
  message: string;
  test: (password: string) => boolean;
}[] = [
  {
    id: 'length',
    label: 'Mínimo de 8 caracteres',
    message: 'A senha deve ter no mínimo 8 caracteres',
    test: (p) => p.length >= 8,
  },
  {
    id: 'uppercase',
    label: 'Uma letra maiúscula',
    message: 'A senha deve conter pelo menos uma letra maiúscula',
    test: (p) => /[A-Z]/.test(p),
  },
  {
    id: 'lowercase',
    label: 'Uma letra minúscula',
    message: 'A senha deve conter pelo menos uma letra minúscula',
    test: (p) => /[a-z]/.test(p),
  },
  {
    id: 'digit',
    label: 'Um número',
    message: 'A senha deve conter pelo menos um número',
    test: (p) => /\d/.test(p),
  },
];

export const checkPasswordRules = (password: string) => {
  const value = password || '';

  return PASSWORD_RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: rule.test(value),
  }));
};

export const validatePassword = (password: string) => {
  const value = password || '';
  const unmet = PASSWORD_RULES.find((rule) => !rule.test(value));

  return {
    isValid: !unmet,
    message: unmet ? unmet.message : ''
  };
};

export const validatePhone = (phone: string) => {

  return {
    isValid: phone && phone.length >= 10 && phone.length <= 11,
    message: 'O telefone deve conter 10 ou 11 dígitos. Exemplo: (14)3222-1234 ou (14)99876-5432'
  }
}